import { useLocale } from '../contexts/index.js'

interface Props {
	donate?: boolean,
}
export function Footer(_: Props) {
	const { locale } = useLocale()

	return <footer>
		<p>
			<span>{locale('developed_by')} <a href="https://github.com/misode" target="_blank" rel="noreferrer">Misode</a></span>
		</p>
	</footer>
}
